import React, { useEffect, useState } from 'react';
import { Form, Modal, Input, Button, Checkbox, Table, Space, Upload, message, Image, Select, Typography, Row, Col, Alert } from 'antd';
import { FileAddOutlined, UserAddOutlined } from '@ant-design/icons';
import { cpuUsage } from 'process';
import { getCurrentUser, listUser } from '../services/User';
import { API_PREFIX } from '../config';
import { Delete, Get, Post } from '../utils/request';
import { Header } from 'antd/lib/layout/layout';
import Title from 'antd/lib/typography/Title';
import { getFixHeader } from '../utils/request';

const layout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 12,
    },
};
const System = () => {
    const [form] = Form.useForm();

    const udpate = () => {
        Get(`/parameter?category=global`, null).then((v) => {
            // const data = v.data;
            console.log("data", v)
            form.setFieldsValue(v.data[0])
        }).catch((e) => {
            console.log("error", e)
        });

    }
    useEffect(() => {
        udpate()

    }, [])

    const saveForm = () => {
        Post(`/parameter?category=global`,{}, form.getFieldsValue()).then(()=>{
            Modal.info({
                title : "提示",
                content:"数据已经保存!"
            })
        })

    }


    return <div style={{ margin: 0 }}>
        <h2 className='title'>系统设置</h2>
        <Row>
            <Col span={24}>
                <Form
                    {...layout}
                    name="basic"
                    form={form}
                    onFinish={saveForm}
                >
                    <Form.Item
                        label="中控名称"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your username!',
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            保存
                        </Button>
                    </Form.Item>
                </Form>
            </Col>
        </Row>

    </div>

};

export default System;